const citys = [
  {
    name:"热门城市",
    children:[     
      {name:"北京",},
      {name:"上海",},
      {name:"深圳",},
      {name:"广州",},
      {name:"重庆",},
      {name:"成都",},
      {name:"武汉",},      
    ],
  },
  {
    name:"A-B",
    children:[              
      {name:"鞍山",},
      {name:"安庆",},
      {name:"安阳",},
      {name:"安顺",},
      {name:"北京",},
      {name:"保定",},
      {name:"包头",},
      {name:"本溪",},
      {name:"白山",},
      {name:"白城",},
      {name:"蚌埠",},
      {name:"滨州",},
      {name:"北海",},
      {name:"巴中",},
      {name:"保山",},
      {name:"宝鸡",},
    ]
  },
  {
    name:"C-D",
    children:[      
      {name:"重庆",},      
      {name:"成都",},      
      {name:"承德",},
      {name:"沧州",},
      {name:"长治",},
      {name:"赤峰",},
      {name:"朝阳",},
      {name:"长春",},//
      {name:"常州",},//
      {name:"滁州",},
      {name:"长沙",},//
      {name:"潮州",},
      {name:"大同",},
      {name:"大连",},//
      {name:"丹东",},
      {name:"大庆",},
      {name:"东营",},
      {name:"德州",},
      {name:"东莞",},
      {name:"德阳",},
      {name:"达州",},
    ]
  },
  {    
    name:"E-F", 
    children:[     
      {name:"鄂尔多斯",},//
      {name:"鄂州",},
      {name:"抚顺",},
      {name:"阜新",},
      {name:"阜阳",},
      {name:"福州",},//
      {name:"抚州",},
      {name:"佛山",},
    ]
  },  
  {
    name:"G",
    children:[      
      {name:"广州",},
      {name:"赣州",},
      {name:"桂林",},
      {name:"广元",},
      {name:"广安",},
      {name:"贵阳",},//
      {name:"邯郸",},
    ]
  }, 
  {
    name:"H",
    children:[                     
      {name:"衡水",},
      {name:"呼和浩特",},//
      {name:"呼伦贝尔",},
      {name:"葫芦岛",},
      {name:"哈尔滨",},//
      {name:"鹤岗",},
      {name:"黑河",},
      {name:"淮安",},
      {name:"杭州",},//
      {name:"合肥",},
      {name:"淮南",},
      {name:"淮北",},
      {name:"黄山",},
      {name:"菏泽",},
      {name:"黄石",},
      {name:"黄冈",},
      {name:"衡阳",},
      {name:"惠州",},//
      {name:"河源",},
      {name:"海口",},
      {name:"汉中",},
      {name:"海东",},
    ]
  },
  {                       
    name:"J",
    children:[
      {name:"晋城",},
      {name:"晋中",},
      {name:"锦州",},
      {name:"吉林",},
      {name:"佳木斯",},//
      {name:"鸡西",},
      {name:"嘉兴",},
      {name:"金华",},
      {name:"吉安",},
      {name:"九江",},
      {name:"景德镇",},
      {name:"济南",},
      {name:"济宁",},
      {name:"焦作",},
      {name:"荆州",},
      {name:"荆门",},
      {name:"江门",},
      {name:"嘉峪关",},
      {name:"金昌",},
    ]
  },
  {                      
    name:"K-L",
    children:[
      {name:"开封",},
      {name:"昆明",},
      {name:"喀什地区",},//
      {name:"廊坊",},
      {name:"临汾",},
      {name:"吕梁",},
      {name:"辽阳",},
      {name:"辽源",},
      {name:"连云港",},
      {name:"丽水",},
      {name:"聊城",},
      {name:"临沂",},
      {name:"莱芜",},
      {name:"洛阳",},
      {name:"柳州",},
      {name:"丽江",},
      {name:"临沧",},
      {name:"拉萨",},
      {name:"兰州",},
      {name:"漯河",},
      {name:"泸州",},
    ]
  },
  {             
    name:"M-N",
    children:[
      {name:"牡丹江",},
      {name:"马鞍山",},
      {name:"茂名",},
      {name:"梅州",},
      {name:"绵阳",},
      {name:"眉山",},
      {name:"南京",},//
      {name:"南通",},
      {name:"宁波",},
      {name:"南平",},
      {name:"南昌",},//
      {name:"南阳",},
      {name:"南宁",},
      {name:"南充",},
    ]
  },
  {                 
    name:"P-R",
    children:[
      {name:"盘锦",},
      {name:"莆田",},
      {name:"平顶山",},
      {name:"攀枝花",},
      {name:"普洱",},
      {name:"濮阳",},
      {name:"秦皇岛",},
      {name:"齐齐哈尔",},
      {name:"泉州",},
      {name:"青岛",},
      {name:"清远",},
      {name:"曲靖",},
      {name:"日照",},
    ]
  },                    
  {
    name:"S",
    children:[
      {name:"上海",},
      {name:"石家庄",},
      {name:"朔州",},
      {name:"沈阳",},//
      {name:"四平",},
      {name:"松原",},
      {name:"绥化",},
      {name:"苏州",},//
      {name:"宿迁",},
      {name:"绍兴",},
      {name:"宿州",},
      {name:"三明",},
      {name:"商丘",},
      {name:"三门峡",},
      {name:"十堰",},
      {name:"邵阳",},
      {name:"深圳",},
      {name:"汕头",},
      {name:"韶关",},
      {name:"汕尾",},
      {name:"三亚",},
      {name:"三沙",},
      {name:"遂宁",},
    ]
  },          
  {
    name:"T",
    children:[
      {name:"天津",},//
      {name:"唐山",},
      {name:"太原",},
      {name:"通辽",},
      {name:"铁岭",},
      {name:"通化",},
      {name:"泰州",},
      {name:"台州",},
      {name:"铜陵",},
      {name:"泰安",},
      {name:"铜川",},
    ]
  },
  {       
    name:"W",
    children:[
      {name:"武汉",},   
      {name:"无锡",},
      {name:"温州",},
      {name:"芜湖",},
      {name:"潍坊",},
      {name:"威海",},
      {name:"梧州",},
      {name:"渭南",},
      {name:"乌鲁木齐",},//
    ]
  },
  {           
    name:"X",
    children:[
      {name:"邢台",},
      {name:"忻州",},
      {name:"徐州",},
      {name:"厦门",},//
      {name:"新乡",},
      {name:"许昌",},
      {name:"襄阳",},
      {name:"孝感",},
      {name:"湘潭",},
      {name:"西安",},
      {name:"咸阳",},
      {name:"西宁",},
    ]
  },
  {               
    name:"Y",
    children:[
      {name:"阳泉",},
      {name:"运城",},
      {name:"营口",},
      {name:"伊春",},
      {name:"盐城",},
      {name:"扬州",},
      {name:"宜春",},
      {name:"烟台",},
      {name:"宜昌",},
      {name:"岳阳",},
      {name:"阳江",},
      {name:"雅安",},
      {name:"玉溪",},
      {name:"延安",},
      {name:"榆林",},
      {name:"银川",},
    ]
  },
  {                
    name:"Z",
    children:[
      {name:"张家口",},
      {name:"镇江",},
      {name:"舟山",},
      {name:"漳州",},
      {name:"淄博",},
      {name:"枣庄",},
      {name:"郑州",},//
      {name:"株洲",},
      {name:"张家界",},
      {name:"珠海",},//
      {name:"湛江",},
      {name:"肇庆",},//
      {name:"中山",},
      {name:"自贡",},
      {name:"遵义",},//
      {name:"昭通",},
    ]
  },
];
export default citys;